import React, { Component } from 'react';

import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

class ContactUs extends Component {
	static propTypes = {};

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	render() {
		return (
			<div className=" content-container cancel-done-section pages-contact-us">
				<div className="contact-us-title page-title font20">
					{i18next.language == 'es' ? 'Nuestros canales de atención' : 'Our support channels'}
					{/* Nuestros canales<span className="bold-text">&nbsp; de atención</span> */}
				</div>

				<div>
					<div className="contact-us-container">
						<div className="kupos-card contact-us-item">
							<div className="cancel-ticket-done">
								<img
									src="/static/images/icon_enquiry.png"
									alt={this.props.t('TRANSLATIONS.ICON_ENQUIRY')}
								/>
							</div>
							<div className="mt-y-3 cancel-ticket-done">
								<span className="bold-text font16">
									{i18next.language == 'es' ? 'Preguntas frecuentes' : 'Frequent questions'}
								</span>
							</div>

							<div className="mt-y-3 cancel-ticket-done" style={{ height: '20%' }}>
								<span className="font10" style={{ minHeight: 60, maxHeight: 70, paddingRight: 12 }}>
									{i18next.language == 'es'
										? 'En nuestro centro de ayuda podrás encontrar respuestas a las preguntas frecuentes, guías paso a paso y tips para tu proceso de compra.'
										: 'In our help center you can find the response to the most common questions, step by step guides and tips for your purchase process.'}
								</span>
							</div>
							<div className="contact-us-input-box">
								<button className="kupos-button font10" onClick={() => window.open('https://pasajebus.freshdesk.com/es/support/home')}>
									<span>{i18next.language == 'es' ? 'Centro de ayuda' : 'Help center'}</span>
								</button>
							</div>
						</div>

						<div className="kupos-card contact-us-item">
							<div className="cancel-ticket-done">
								<img src="/static/images/icon_chat.png" alt={this.props.t('TRANSLATIONS.ICON_CHAT')} />
							</div>
							<div className="mt-y-3 cancel-ticket-done">
								<span className="bold-text font16">
									{i18next.language == 'es' ? 'Escríbenos' : 'Get in touch with us!'}
								</span>
							</div>

							<div className="mt-y-3 cancel-ticket-done">
								<span className="font10" style={{ minHeight: 60, maxHeight: 70 }}>
									{i18next.language == 'es'
										? 'Si no encontraste lo que buscabas en nuestro centro de ayuda, escríbenos a nuestro chat en línea. Te responderemos lo más rápido posible.'
										: "If you couldn't find what you were looking for in our help center, chat with us online! We will get back at you as soon as possible."}
								</span>
							</div>
							<div className="contact-us-input-box">
								<button className="kupos-button font10" onClick={() => window.open('https://pasajebus.freshdesk.com/es/support/solutions')}>
									<span>{i18next.language == 'es' ? 'Contáctanos' : 'Contact us'}</span>
								</button>
							</div>
						</div>
					</div>

					<div className="contact-us-container contact-details font10">
						<div className="kupos-card contact-us-item ">
							<div className="contact-us-item-heading font13">
								{i18next.language == 'es' ? (
									<span>
										También puedes <span className="bold-text">contactarnos a:</span>
									</span>
								) : (
									<span>
										You can connect <span className="bold-text">with us to:</span>
									</span>
								)}
							</div>
							<div className="display-flex contact-us-icons-and-text">
								<div className="contact-number">
									<img src="/static/images/icon_phone.png" alt={this.props.t('TRANSLATIONS.ICON_PHONE')} />
									<span>+56 9 4915 6683</span>
								</div>
								<div className="contact-number">
									<img
										src="/static/images/icon_whatsapp.png"
										alt={this.props.t('TRANSLATIONS.ICON_WHATSAPP')}
									/>
									<span>+56 9 4915 6683</span>
								</div>
							</div>

							<div className="display-flex contact-us-icons-and-text">
								<img src="/static/images/icon_email.png" alt={this.props.t('TRANSLATIONS.ICON_MAIL')} />
								<a href="mailto:ayuda@pasajebus.com">
									<span>ayuda@pasajebus.com</span>
								</a>
							</div>
						</div>

						<div className="kupos-card contact-us-item">
							<div className="contact-us-item-heading font13">
								{i18next.language == 'es' ? (
									<span>
										Horarios de <span className="bold-text">&nbsp;atención:</span>
									</span>
								) : (
									<span>
										We are <span className="bold-text">&nbsp;available from:</span>
									</span>
								)}
							</div>
							<div className="display-flex contact-us-icons-and-text">
								<div>
									{i18next.language == 'es' ? (
										<span>
											<span className="bold-text">Lunes a viernes: </span>9:00AM - 23:30PM
										</span>
									) : (
										<span>
											<span className="bold-text">Monday to friday: </span>9:00AM - 23:30PM
										</span>
									)}
								</div>
							</div>

							<div className="display-flex contact-us-icons-and-text">
								<div>
									{i18next.language == 'es' ? (
										<span>
											<span className="bold-text">Sábados, domingos y feriados: </span>9:00AM -
											19:00PM
										</span>
									) : (
										<span>
											<span className="bold-text">Saturdays, sundays and holidays: </span> 9:00AM -
											19:00PM
										</span>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation('common')(ContactUs);



// WEBPACK FOOTER //
// ./src/features/pages/ContactUs.js